import React from "react";

import { Row, Col, Table, Button, Popconfirm, Divider } from "antd";
import { EditOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { Form, Select, Input } from "formik-antd";

import { isNotValid, translateSymfonyErrorToFormik } from "../../../core/utils/form";

import { v4 } from "uuid";

/* Form & Form Validation */
import * as Yup from "yup";

import ModalForm from "./../../../core/components/form/modalForm";

const validationSchema = Yup.object().shape({
    type: Yup.string().required("Cannot be blank."),
    email: Yup.string().when("type", {
        is: (type) => type == TYPE_PAYPAL,
        then: Yup.string().email("Invalid email.").required("Cannot be blank."),
    }),
    information: Yup.string().when("type", {
        is: (type) => type == TYPE_OTHER,
        then: Yup.string().required("Cannot be blank."),
    }),
    bank_name: Yup.string().when("type", {
        is: (type) => type == TYPE_BANK_TRANSFER,
        then: Yup.string().required("Cannot be blank."),
    }),

    account_number: Yup.string().when("type", {
        is: (type) => type == TYPE_BANK_TRANSFER,
        then: Yup.string().required("Cannot be blank."),
    }),
});

export const TYPE_BANK_TRANSFER = "Bank Transfer";
export const TYPE_PAYPAL = "PayPal";
export const TYPE_OTHER = "Other";

export const defaultValue = {
    type: TYPE_BANK_TRANSFER,
    bank_name: "",
    account_number: "",
    notes: "",
};

export default class FormMethod extends React.Component {
    constructor(props) {
        super(props);
    }

    handleSubmit = (values, bag) => {
        let form = {
            ...values,
        };

        if (!values.id) {
            form = {
                id: v4(),
                ...form,
            };
        }

        const ret = this.props.updatePaymentMethod(this.props.vendor.id, form);

        ret.then((response) => {
            bag.setSubmitting(false);
            if (isNotValid(response)) {
                bag.setErrors(translateSymfonyErrorToFormik(response.errors.children));
            } else {
                this.props.onCancel();
            }
        }).catch((e) => {
            alert("Se ha producido un error desconocido");
        });
    };

    handleTypeChange = (type, setFieldValue) => {
        if (type != TYPE_BANK_TRANSFER) {
            setFieldValue("bank_name", undefined);
            setFieldValue("account_holder", undefined);
            setFieldValue("account_number", undefined);
            setFieldValue("swift_code", undefined);
            setFieldValue("aba_ach_code", undefined);
            setFieldValue("currency", undefined);
        }

        if (type == TYPE_BANK_TRANSFER) {
            setFieldValue("bank_name", "");
            setFieldValue("account_number", "");
        }

        if (type != TYPE_PAYPAL) {
            setFieldValue("email", undefined);
        }

        if (type == TYPE_PAYPAL) {
            setFieldValue("email", "");
        }

        if (type != TYPE_OTHER) {
            setFieldValue("information", undefined);
        }

        if (type == TYPE_OTHER) {
            setFieldValue("information", "");
        }
    };

    render() {
        const { item, modalVisible, onCancel } = this.props;
        return (
            <ModalForm
                title="Payment Method"
                enableReinitialize={true}
                initialValues={item}
                validationSchema={validationSchema}
                onSubmit={this.handleSubmit}
                onCancel={onCancel}
                visible={modalVisible}
                render={({ isSubmitting, touched, errors, values, setFieldValue, setFieldTouched }) => (
                    <>
                        <Form.Item label="Type" name="type" hasFeedback={true} showValidateSuccess={true} required>
                            <Select
                                placeholder="Type"
                                name="type"
                                onChange={(value) => this.handleTypeChange(value, setFieldValue)}
                            >
                                <Select.Option value={TYPE_BANK_TRANSFER}>{TYPE_BANK_TRANSFER}</Select.Option>
                                <Select.Option value={TYPE_PAYPAL}>{TYPE_PAYPAL}</Select.Option>
                                <Select.Option value={TYPE_OTHER}>{TYPE_OTHER}</Select.Option>
                            </Select>
                        </Form.Item>
                        {values.type == TYPE_BANK_TRANSFER && (
                            <>
                                <Form.Item label="Bank Name" name="bank_name" hasFeedback={true} required>
                                    <Input name="bank_name" placeholder="Bank Name" />
                                </Form.Item>
                                <Form.Item label="Account Holder" name="account_holder" hasFeedback={true}>
                                    <Input name="account_holder" placeholder="Account Holder" />
                                </Form.Item>
                                <Form.Item label="Account Number" name="account_number" hasFeedback={true} required>
                                    <Input name="account_number" placeholder="Account Number" />
                                </Form.Item>
                                <Form.Item label="SWIFT/BIC" name="swift_code" hasFeedback={true}>
                                    <Input name="swift_code" placeholder="SWIFT/BIC" />
                                </Form.Item>
                                <Form.Item label="ABA/ACH" name="aba_ach_code" hasFeedback={true}>
                                    <Input name="aba_ach_code" placeholder="ABA/ACH" />
                                </Form.Item>
                                <Form.Item label="Currency" name="currency" hasFeedback={true}>
                                    <Input name="currency" placeholder="Currency" />
                                </Form.Item>
                            </>
                        )}
                        {values.type == TYPE_PAYPAL && (
                            <Form.Item label="Email" name="email" hasFeedback={true} showValidateSuccess={true}>
                                <Input name="email" placeholder="Email" />
                            </Form.Item>
                        )}
                        {values.type == TYPE_OTHER && (
                            <Form.Item
                                label="Information"
                                name="information"
                                hasFeedback={true}
                                showValidateSuccess={true}
                            >
                                <Input name="information" placeholder="Information" />
                            </Form.Item>
                        )}
                        <Form.Item label="Notes" name="notes">
                            <Input.TextArea name="notes" placeholder="Notes" />
                        </Form.Item>
                    </>
                )}
            />
        );
    }
}
